// product-form.js — District-compatible + Appstle subscription support (final)

class ProductFormElement extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;

    this.form.addEventListener('submit', (evt) => this.onSubmitHandler(evt));

    const notifications = document.querySelectorAll('cart-notification');
    this.cartNotification = notifications[notifications.length - 1];

    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector('span');
    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  onSubmitHandler(e) {
    e.preventDefault();

    const loadingCls = 'loading';
    if (this.submitButton.classList.contains(loadingCls)) return;

    this.handleErrorMessage();
    this.cartNotification.setActiveElement(document.activeElement);

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add(loadingCls);

    // Theme fetch config (same as District)
    const req = theme.fetchConfig('javascript');
    req.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete req.headers['Content-Type'];

    // --- Capture the selected Appstle selling plan (robust across widget locations) ---
    // Look BOTH inside and outside the form so it works even if the widget renders at the bottom.
    let planId = null;

    (function () {
      const candidates = Array.prototype.slice.call(document.querySelectorAll(
        '#appstle_selling_plan,' +                      // our hidden input (if populated)
        'input[name="selling_plan"],' +                 // generic input some widgets use
        'input[name="appstle_selected_selling_plan"],' +// common alternate name
        'select[name="selling_plan"],' +                // select-based widgets
        'select[name="appstle_selling_plan"]'
      ));

      for (let el of candidates) {
        if (!el) continue;
        if (el.tagName === 'SELECT') {
          if (el.value) { planId = el.value; break; }
        } else if (el.type === 'radio') {
          if (el.checked && el.value) { planId = el.value; break; }
        } else {
          if (el.value) { planId = el.value; break; }
        }
      }
    })();

    // Mirror into our hidden field so FormData will include it if the widget is inside the form
    const hiddenSellingPlan = this.form.querySelector('#appstle_selling_plan');
    if (hiddenSellingPlan && planId) {
      hiddenSellingPlan.value = planId;
    }

    // Build payload from the whole form (variant id, qty, etc.) — keep variable name "i" like original
    const i = new FormData(this.form);

    // Ensure selling_plan is present in the payload even if the widget lives outside the form
    if (planId) {
      i.set('selling_plan', planId);
    } else if (hiddenSellingPlan && hiddenSellingPlan.value) {
      i.set('selling_plan', hiddenSellingPlan.value);
    }

    // (Original theme behavior) include sections to re-render the cart UI
    i.append('sections', this.cartNotification.getSectionsToRender().map(s => s.id));
    i.append('sections_url', window.location.pathname);

    req.body = i;

    fetch(`${theme.routes.cart_add_url}`, req)
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          // Theme pub/sub (unchanged)
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: i.get('id'),
            errors: data.errors || data.description,
            message: data.message
          });
          this.handleErrorMessage(data.description);
          return;
        }

        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: i.get('id'),
            cartData: data
          });
        }

        this.error = false;
        this.cartNotification.renderContents(data);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.submitButton.classList.remove(loadingCls);
        this.submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageContainer =
      this.errorMessageContainer || this.querySelector('.product-form__error-container');
    this.errorMessage =
      this.errorMessage || this.errorMessageContainer.querySelector('.product-form__error-message');

    this.errorMessageContainer.toggleAttribute('hidden', !errorMessage);
    if (errorMessage) this.errorMessage.textContent = errorMessage;
  }
}

// ✅ Keep hidden #appstle_selling_plan in sync with Appstle widget changes
document.addEventListener('change', function (e) {
  const t = e.target;
  if (!t || !t.name) return;

  // Appstle renders radios/selects with names that usually include 'appstle' or 'selling_plan'
  if (t.name.includes('appstle') || t.name.includes('selling_plan')) {
    const form = t.closest('form');
    const hidden = form && form.querySelector('#appstle_selling_plan');
    const value = t.value || t.getAttribute('value');
    if (hidden && value) hidden.value = value;
  }
});

customElements.define('product-form', ProductFormElement);
